import * as React from 'react';
import { Suspense } from 'react';
import Modal from '../Modal';

type Props = {
    fallback?: React.ReactNode;
    enableErrorModal?: boolean;
};

class ModalErrorBoundary extends React.Component<
    React.PropsWithChildren<{ enableErrorModal: boolean }>,
    { error: null | unknown; showModalOnError: boolean }
> {
    state = {
        error: null,
        showModalOnError: true,
    };

    static getDerivedStateFromError(error: unknown) {
        return { error, showModalOnError: true };
    }

    closeModal = () => {
        this.setState({ showModalOnError: false });
    };

    render() {
        if (this.state.error) {
            return (
                <Modal
                    isOpen={this.props.enableErrorModal && this.state.showModalOnError}
                    onClose={this.closeModal}
                    status="error"
                    size="SM_WIDTH"
                    title="Something Went Wrong"
                >
                    <p>Your last action couldn't be performed. Please reload the page and try again.</p>
                </Modal>
            );
        }
        return this.props.children;
    }
}

const SuspenseWithErrorModal: React.FC<React.PropsWithChildren<Props>> = ({
    children,
    fallback,
    enableErrorModal = true,
}) => (
    <ModalErrorBoundary enableErrorModal={enableErrorModal}>
        <Suspense fallback={fallback ?? null}>{children}</Suspense>
    </ModalErrorBoundary>
);

export default SuspenseWithErrorModal;
